import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import { useRouteAccess } from 'src/routes/routeAccess';
import { selectCurrentUser } from 'src/store/storeUtils';
import { updateUserAttributes } from 'src/store/user/actions';

const DISMISS_DURATION_MONTHS = 3;

export function useReferralPromo() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  // The settings page's gate already folds in growth-loops, internal users
  // only, and no freemium or trial workspaces.
  const { routeAccess } = useRouteAccess();
  const dismissedAt = useAppSelector(
    (state) => selectCurrentUser(state)?.fields?.referralPromoDismissedAt,
  );
  // The saved timestamp only reaches the store via the websocket echo, so
  // hide the card now rather than after the round trip.
  const [isDismissedLocally, setIsDismissedLocally] = useState(false);

  // The dismissal lives on the user record, not the portal, so it hides the
  // promo for this person only and lapses so the promo can return.
  const isDismissed =
    isDismissedLocally ||
    (!!dismissedAt &&
      moment().isBefore(
        moment(dismissedAt).add(DISMISS_DURATION_MONTHS, 'months'),
      ));

  const isVisible = routeAccess.allowSettingsReferralPage && !isDismissed;

  const dismiss = () => {
    setIsDismissedLocally(true);
    dispatch(
      updateUserAttributes(
        // The server stamps the time, so the snooze runs on its clock.
        { dismissReferralPromo: true },
        {
          successMessage: t(($) => $.page_settings_referrals.promo.dismissed),
        },
      ),
    );
  };

  return { isVisible, dismiss };
}
